import { Accomodation } from "./accomodation.model";
export class AccomodationTranslation{
    /*
    *
    */
   constructor(
        public detail?: string,
        public locale?: string,
        public accomodation?: Accomodation
    ){}
}